import React from 'react'
import PropTypes from 'prop-types'

const PrintableContent = ({ children }) => {
    return (
        <div>
            <style>
                {`
                /* Print-specific styles */
                @media print {
                    /* Hide everything except the printable area */
                    body * {
                        visibility: hidden;
                    }
                    #printable-content, #printable-content * {
                        visibility: visible;
                    }
                    #printable-content {
                        position: absolute;
                        left: 0 !important;
                        top: 0 !important;
                        width: 100% !important;
                        margin: 0 !important;
                        padding: 0 !important;
                    }
                    /* Ensure no layout shifts from sidebar */
                    .site-layout-sider, 
                    .site-layout-header {
                        display: none !important;
                    }
                    /* Reset any content margin/padding */
                    #main-content {
                        margin: 0 !important;
                        padding: 0 !important;
                        width: 100% !important;
                        max-width: 100% !important;
                    }
                }
                `}
            </style>
            <div id='printable-content'>{children}</div>
        </div>
    )
}

PrintableContent.propTypes = {
    children: PropTypes.node.isRequired,
}

export default PrintableContent
